module.exports = require("./fr-BI");